import { defineComponent, useSlots, computed, useAttrs, watch, createElementBlock, openBlock, normalizeStyle, normalizeClass, createElementVNode, withDirectives, renderSlot, createBlock, createCommentVNode, unref, toDisplayString, mergeProps, vShow } from "vue";
import { S as SIZES } from "./p-btn.types.js";
import { _ as _sfc_main$1 } from "./p-info-icon.js";
import { useInputClasses } from "../useInputClasses.js";
import { toNumberOrNull } from "../number.js";
import { kebabCase } from "lodash-es";
import { useCurrencyInput } from "vue-currency-input";
const _hoisted_1 = ["data-has-error"];
const _hoisted_2 = { class: "flex flex-row items-center" };
const _hoisted_3 = { class: "relative w-full" };
const _hoisted_4 = { key: 0 };
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PInputNumber",
    inheritAttrs: false
  },
  __name: "p-input-number",
  props: {
    modelValue: {
      type: [Number, String],
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    errorMsg: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "md",
      validator(value) {
        return SIZES.includes(value);
      }
    },
    selectOnClick: {
      type: Boolean,
      default: true
    },
    tooltipText: {
      type: String,
      default: ""
    },
    prefixString: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "change"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const ALL_OPTIONS = [
      "locale",
      "currency",
      "currencyDisplay",
      "hideGroupingSeparatorOnFocus",
      "hideCurrencySymbolOnFocus",
      "hideNegligibleDecimalDigitsOnFocus",
      "precision",
      "autoDecimalDigits",
      "valueRange",
      "useGrouping",
      "valueScaling"
    ];
    const prefixClasses = {
      sm: "text-sm h-8 left-2",
      md: "text-base h-10 left-3",
      lg: "text-lg h-12 left-5"
    };
    const emit = __emit;
    const props = __props;
    const slots = useSlots();
    const { labelClasses, inputClasses, errorMsgClasses } = useInputClasses(
      computed(() => ({
        ...props,
        prefix: !!slots.prefix || !!props.prefixString,
        suffix: !!slots.suffix
      }))
    );
    const attrs = useAttrs();
    const DEFAULTS = {
      locale: "en-US",
      currency: "USD",
      precision: 0,
      currencyDisplay: "hidden"
    };
    const inputCurrencyOptions = computed(() => {
      ALL_OPTIONS.forEach((key) => {
        const attr = attrs[kebabCase(key)];
        if (attr && typeof attr !== "undefined") {
          DEFAULTS[key] = attr;
        }
      });
      return DEFAULTS;
    });
    const { inputRef, numberValue, setValue } = useCurrencyInput(
      inputCurrencyOptions.value,
      false
    );
    watch(numberValue, (value) => {
      emit("update:modelValue", toNumberOrNull(value));
    });
    watch(
      () => props.modelValue,
      (value) => {
        setValue(toNumberOrNull(value));
      }
    );
    const computedAttrs = computed(() => {
      const { class: classes, style: style2, ...rest } = attrs;
      return rest;
    });
    const style = computed(() => {
      return attrs.style;
    });
    const focus = () => {
      props.selectOnClick && inputRef.value.select();
    };
    __expose({ setValue });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([{ hidden: _ctx.$attrs.hidden }, _ctx.$attrs.class]),
        "data-has-error": !!__props.errorMsg,
        style: normalizeStyle(style.value)
      }, [
        createElementVNode("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "label", {
            label: __props.label,
            labelClasses: unref(labelClasses)
          }, () => [
            __props.label ? (openBlock(), createElementBlock("label", {
              key: 0,
              class: normalizeClass(unref(labelClasses))
            }, toDisplayString(__props.label), 3)) : createCommentVNode("", true)
          ]),
          __props.tooltipText ? (openBlock(), createBlock(_sfc_main$1, {
            key: 0,
            text: __props.tooltipText,
            class: "ml-1"
          }, null, 8, ["text"])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_3, [
          !!_ctx.$slots.prefix || __props.prefixString ? (openBlock(), createElementBlock("div", _hoisted_4, [
            renderSlot(_ctx.$slots, "prefix", {}, () => [
              createElementVNode("div", {
                class: normalizeClass([{ "absolute left-3 flex items-center": __props.prefixString }, __props.prefixString ? prefixClasses[__props.size] : ""])
              }, toDisplayString(__props.prefixString), 3)
            ])
          ])) : createCommentVNode("", true),
          createElementVNode("input", mergeProps({
            ref_key: "inputRef",
            ref: inputRef,
            type: "text"
          }, computedAttrs.value, {
            class: unref(inputClasses),
            onFocus: focus
          }), null, 16)
        ]),
        withDirectives(createElementVNode("div", {
          class: normalizeClass(unref(errorMsgClasses))
        }, toDisplayString(__props.errorMsg), 3), [
          [vShow, __props.errorMsg]
        ])
      ], 14, _hoisted_1);
    };
  }
});
export {
  _sfc_main as _
};
